<template>
  <div class="product is-gray">
    <div class="image d-flex align-items-center justify-content-center">
      <a :href="getUrl(item)">
        <img
          :src="item.iconImage"
          :alt="item.name"
          class="img-fluid"
          onerror="this.src = '/images/comingsoon.png'"
          width="145"
          height="145"
        />
      </a>
      <div
        class="hover-overlay d-flex align-items-center justify-content-center"
      >
        <div class="CTA d-flex align-items-center justify-content-center">
          <!--<a href=""class="add-to-cart"><i class="fa fa-shopping-cart"></i></a>-->
          <a :href="getUrl(item)" class="visit-product active"
            ><i class="icon-search"></i>View</a
          >
          <!--<a href=""data-toggle="modal" data-target="#exampleModal" class="quick-view"><i class="fa fa-arrows-alt"></i></a>-->
        </div>
      </div>
    </div>
    <div class="title">
      <a :href="getUrl(item)">
        <h3 class="h6 text-uppercase no-margin-bottom">
          {{ item.name }}
        </h3>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CatalogItem } from '../common/CatalogItem';

defineProps<{
  item?: CatalogItem;
}>();

function getUrl(item: { id: string }): string {
  return '/prints/' + item.id + '/styles';
}
</script>

<style scoped></style>
